import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAndroid, faApple } from '@fortawesome/free-brands-svg-icons'

export const OsIcon = ({os, style}) => {
  if (os == "android") {
    return(<FontAwesomeIcon icon={faAndroid} style={style}/>)
  } else if (os == "ios") {
    return (<FontAwesomeIcon icon={faApple} style={style}/>)
  } else {
    return(<></>)
  }
}
